<template>
   <div>
      <h4>Overview</h4>

      <ul ref="pocCon" class="poc-container">
         <li
            v-for="(item, index) in items"
            :key="index"
            :class="[
               'poc-container-parent-li',
               { active: index === 0 },
               { 'has-child': item.children },
            ]"
         >
            <i v-if="item.children" class="fc_indicator_right" />
            <a
               :title="'Go to ' + item.header"
               :class="{ 'pl-1': !item.children }"
               :href="'#' + item.id"
               @click="go"
            >
               {{ item.header }}
            </a>
            <ul v-if="item.children">
               <li
                  v-for="(subItem, _index) in item.children"
                  :key="_index"
                  class="poc-container-child-li"
               >
                  <a :title="subItem.header" :href="'#' + subItem.id" @click="go">
                     {{ subItem.header }}
                  </a>
               </li>
            </ul>
         </li>
      </ul>
   </div>
</template>

<script>
export default {
   name: 'POC',
   props: {
      items: {
         type: Array,
         default: () => [],
      },
      headerList: {
         type: Object,
         default: () => {},
      },
   },
   data() {
      return {
         isScrolling: false,
      };
   },
   mounted() {
      const list = {};

      this.$refs.pocCon.querySelectorAll('a').forEach(item => {
         list[item.href.split('#')[1]] = item;
      });

      this.initScrollSpy(list);
   },
   methods: {
      update() {
         const sections = this.sections.map(ob => {
            ob.offset = ob.item.offsetTop;
            return ob;
         });
         this.sections = sections;
      },
      expand(parentElm) {
         const removeActiveChild = () => {
            const activeItem = document.querySelector('.poc-container-child-li.active');
            if (activeItem) {
               activeItem.classList.remove('active');
            }
         };
         // do something for the expanding
         // if it is a h3 element
         if (parentElm.classList.contains('poc-container-child-li')) {
            // if it does not contains active class
            if (!parentElm.classList.contains('active')) {
               removeActiveChild();
               parentElm.classList.add('active');
               // parentElm.classList.add('active');
               // get the parent and expand it
               this.expand(parentElm.parentNode.parentNode);
            }
         } else if (parentElm.classList.contains('poc-container-parent-li')) {
            // h2 element
            if (!parentElm.classList.contains('active')) {
               const parentActiveElm = document.querySelector('.poc-container-parent-li.active');
               if (parentActiveElm) parentActiveElm.classList.remove('active');
               parentElm.classList.add('active');
            }

            if (!parentElm.classList.contains('has-child')) {
               removeActiveChild();
            }
         }
      },

      go(e) {
         e.preventDefault();
         const elm = e.target;
         const parentElm = elm.parentNode;
         // expand
         this.expand(parentElm, true);
         this.isScrolling = true;

         // scroll for everyelement
         this.scrollTo(elm.href.split('#')[1]);
         setTimeout(() => {
            this.isScrolling = false;
         }, 1400);
      },

      scrollTo(id) {
         for (let i = 0, ii = this.sections.length; i < ii; i += 1) {
            if (this.sections[i].id === id) {
               const currentPos = document.documentElement.scrollTop;
               const goingTo = this.sections[i].offset + 80;
               const travelTime =
                  Math.abs(currentPos - goingTo) > 1200
                     ? 1000
                     : (Math.abs(currentPos - goingTo) * 1000) / 1200;
               const offSetTop = this.sections[i].offset
                  ? this.sections[i].offset
                  : this.sections[i].item.offsetTop;
               fusionDesign.scroll.to(offSetTop + 50, Math.round(travelTime), 'easeInOutExpo');
            }
         }
      },

      initScrollSpy(lists) {
         const parentCon = document.getElementById('markDownContainer');
         const section = parentCon.querySelectorAll('h2, h3');
         const sections = [];
         let oldActiveDomID = null;
         const updateToc = scrollPosition => {
            for (let i = 0, ii = sections.length; i < ii; i += 1) {
               if (!sections[i].offset) {
                  sections[i].offset = sections[i].item.offsetTop;
               }

               const min = sections[i].offset <= scrollPosition;
               const max = sections[i + 1]
                  ? scrollPosition < (sections[i + 1].offset || sections[i + 1].item.offsetTop)
                  : true;

               if (min && max && !sections[i].isActive) {
                  // remove from old
                  if (oldActiveDomID !== null && sections[oldActiveDomID].isActive) {
                     sections[oldActiveDomID].isActive = false;
                  }
                  // add new stuff
                  oldActiveDomID = i;
                  sections[i].isActive = true;
                  // expand the element
                  if (!this.isScrolling) this.expand(lists[sections[i].id].parentNode, false);
               }
            }
         };

         // const bstScroll = (list, scrollPosition) => {
         //    let middleIndex = null;
         //    // let middle = 0;
         //    while (list.length > 0) {
         //       middleIndex = Math.floor(list.length / 2);
         //       // middle = list[middleIndex];

         //       if (!sections[middleIndex].offset) {
         //          sections[middleIndex].offset = sections[middleIndex].item.offsetTop;
         //       }

         //       const min = sections[middleIndex].offset <= scrollPosition;
         //       const max = sections[middleIndex + 1] ? scrollPosition < (sections[middleIndex + 1].offset || sections[middleIndex + 1].item.offsetTop) : true;

         //       if (min && max && !sections[middleIndex].isActive) {
         //          // remove from old
         //          if (oldActiveDomID !== null && sections[oldActiveDomID].isActive) {
         //             sections[oldActiveDomID].isActive = false;
         //          }
         //          // add new stuff
         //          oldActiveDomID = middleIndex;
         //          sections[middleIndex].isActive = true;
         //          // expand the element
         //          if (!this.isScrolling) this.expand(lists[sections[middleIndex].id].parentNode, false);
         //          break;
         //       }

         //       if (sections[middleIndex].offset > scrollPosition) {
         //          list = list.slice(0, middleIndex);
         //       } else {
         //          list = list.slice(middleIndex + 1);
         //       }
         //    }
         // };

         Array.prototype.forEach.call(section, e => {
            sections.push({ id: e.id, isActive: false, item: e });
         });

         this.sections = sections;

         window.onscroll = () => {
            const scrollPos = document.documentElement.scrollTop || document.body.scrollTop;
            updateToc(scrollPos);
            // bstScroll(sections, scrollPos);
         };
      },
   },
};
</script>

<style lang="scss" scoped>
.poc-container {
   padding-left: 0;
   li {
      overflow: hidden;
      margin-bottom: 0.5rem;
      // max-height: 22px;

      &.poc-container-parent-li {
         padding-left: 2px;
         margin-bottom: 8px;
         ul {
            overflow: hidden;
            li:first-child {
               padding-top: 12px;
            }
         }
      }

      &.poc-container-child-li {
         margin-bottom: 8px;
      }

      a {
         padding-left: 12px;
         display: block;
         color: #5a5b75;
         font-size: 14px;
         letter-spacing: 0.2px;
         line-height: 20px;
         text-decoration: none;
         transition: all ease 0.2s;

         &:hover {
            color: #434456;
         }
      }

      i {
         display: block;
         float: left;
         font-size: 8px;
         margin-right: 2px;
         color: #9b9cb0;
         line-height: 21px;
         transition: all ease 0.35s;
      }

      ul {
         max-height: 0;
         margin: 0;
         transition: max-height ease 0.8s;
         padding-left: 10px;
         li {
            margin: 0;
         }
      }

      &.active {
         & > a {
            font-weight: 600;
            color: #434456;
         }
         ul {
            max-height: 400px;
         }
         & > i {
            transform: rotate(90deg);
         }
      }

      &:hover {
         & > a {
            color: #434456;
         }
      }
   }
}
</style>
